import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { GoodsPhoto, Confirm, Alert } from "../../../js/ComponentManager";
import { Link } from 'react-router-dom';

/* 개발담당:양유빈
 * 화면기능:주문 상세
 * 세부설명:
*/

export class OrderDtl extends Component {
    static displayName = OrderDtl.name;

    constructor(props) {
        super(props);
        this.state = {
            OrdDtl: [],
            Summary: [],
            Title:""
        };
        this.Ordgrp_No = "";
        this.Union_Uid = "";
        this.Ord_Status = "";
        this.handleCancel_Click = this.handleCancel_Click.bind(this);
        this.handleComplete_Click = this.handleComplete_Click.bind(this);
        this.handleSubmit_Click = this.handleSubmit_Click.bind(this);
        this.handleGoods_Click = this.handleGoods_Click.bind(this);
        
    }
    //초기화
    componentDidMount() {
        this.CallOrdMgtMstDtlData();     
    }
    //주문상세
    async CallOrdMgtMstDtlData() {

        if (this.props.ContentState !== undefined && this.props.ContentState != null) {
            this.Ordgrp_No = this.props.ContentState.Ordgrp_No;
            this.Union_Uid = this.props.ContentState.Union_Uid;
        }
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Order/OrderMgr/GetOrdMgtMstDtl',
                {
                    Ordgrp_No: this.Ordgrp_No,
                    Union_Uid: this.Union_Uid
                }, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const OrdDtl = DataList.OrdDtl;
                const Summary = DataList.Summary;
                this.setState({ OrdDtl: OrdDtl, Summary: Summary });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallOrdMgtMstDtlData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //주문 취소
    handleCancel_Click(event,ord_status) {
        Big3Common.ModalAlert(bootstrap, "OrderCancel");
        this.Ord_Status = ord_status;
        event.preventDefault();
    }
    //주문완료/포장완료
    handleComplete_Click(event, ord_status) {
        Big3Common.ModalAlert(bootstrap, "OrderComplete");
        this.Ord_Status = ord_status;
        event.preventDefault();
    }
    //데이터 처리
    Ord_Use = "";
    async handleSubmit_Click() {
        try {
           
            let Data = await Big3Common.Post('api/Order/OrderMgr/ModifyOrdMgtMstToStatus',
                {
                    Ordgrp_No: this.Ordgrp_No,
                    Union_Uid: this.Union_Uid,
                    Ord_Status: this.Ord_Status,
                    Ord_Use: this.Ord_Use,
                    Ord_Dt: this.state.Summary[0].ord_dt
                }, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {

                let ComName = "OrderList";

                if (this.Ord_Status === "GR") {
                    ComName = "CompletedList";
                }
                let ContentState = this.props.ContentState;
                //현장방문, 택배주분은 포장 완료 시 주문완료 됨
                if (this.Ord_Status === "PJ" && (this.Ord_Use === "HB" || this.Ord_Use === "TJ")) {
                    ComName = "CompletedList";
                    //변경된 Ord_Status 변경
                    ContentState.Ord_Status = "GR";
                }
                else {
                    ContentState.Ord_Status = this.Ord_Status;
                }                
                this.props.RenderComponent(ComName, ContentState);
            }
            else {
                this.setState({ Title: Data.message });
                Big3Common.ModalAlert(bootstrap, "AlertBox");
            }
        }
        catch (e) {
            console.log("handleSubmit_Click: ", e)
        }
        return false;
    }
    handleGoods_Click(goods_No) {
        let ContentState = this.props.ContentState;
        ContentState.Goods_No = goods_No
        this.props.RenderComponent("GoodsDtl", ContentState);
    }
    GoodsOrderrender(OrderList) {
        return (
            <>
                {
                    <div className="table_box" >
                        <React.Fragment>
                            <table className="table">
                                <colgroup>
                                    <col width="44%" />
                                    <col width="12%" />
                                    <col width="44%" />
                                </colgroup>
                                <tbody>
                                    {OrderList.map(list =>
                                        <tr key={list.ordno}>
                                            <td>{list.crd_cd_nm}  / {list.size_nm}  ({Big3Common.Util.Money(list.goods_price)})</td>
                                            <td>{list.quan}</td>
                                            <td>{Big3Common.Util.Money(list.goods_price_sum)}원</td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td>합계</td>
                                        <td>{OrderList.reduce((acc, item) => acc + item.quan, 0)}</td>
                                        <td>{Big3Common.Util.Money(OrderList.reduce((acc, item) => acc + item.goods_price_sum, 0))}원</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </React.Fragment>
                    </div>
                }
            </>
        )
    }
    Goodsrender() {
        
        const OrdDtl = this.state.OrdDtl;
        const GoodsList = Big3Common.Util.groupBy(OrdDtl, list => list.goods_no);
       
        const OrdDtListJson = [];
        for (const item of GoodsList.entries()) {
            OrdDtListJson.push({
                "GoodsNo": item[0],
                "OrderList": item[1],
            });
        }
        return (
            <>
                {
                    OrdDtListJson.map(list =>
                        <div className="order_dtl_box" key={list.GoodsNo }>
                            <div className="order_goods_info">
                                <div className="order_goods_img" onClick={() => this.handleGoods_Click(list.GoodsNo) }>
                                    <GoodsPhoto
                                        className="order_goods_img_in"
                                        ImageSrc={list.OrderList[0].img_220}
                                    />
                                </div>
                                <div className="order_txt">
                                    <div className="goods_title">{list.OrderList[0].goods_nm}</div>
                                    <div className="goods_price">{Big3Common.Util.Money(list.OrderList[0].goods_price)}원</div>
                                </div>
                            </div>
                            {this.GoodsOrderrender(list.OrderList)}
                        </div>
                    )
                } 
                <div className="table_box sum_table">
                    <React.Fragment>
                        <table className="table">
                            <colgroup>
                                <col width="44%" />
                                <col width="12%" />
                                <col width="44%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td>총 합계</td>
                                    <td>{OrdDtl.reduce((acc, item) => acc + item.quan, 0) }</td>
                                    <td>{Big3Common.Util.Money(OrdDtl.reduce((acc, item) => acc + item.goods_price_sum, 0))}원</td>
                                </tr>
                            </tbody>
                        </table>
                    </React.Fragment>
                </div>
            </>
        )
    }
    Buttonrender(ord_status) {
        if (ord_status === "JM") {
            //현재 주문상태
            return (
                <div className="catagory_button_box">
                    <button type="button" className="r_btn_v btn_v1" onClick={(e) => { this.handleComplete_Click(e, 'PJ') }}>포장완료</button>
                    <button type="button" className="r_btn_v btn_inactive" onClick={(e) => { this.handleCancel_Click(e, 'CS') }}>주문취소</button>
                </div>
            )
        }
        else if (ord_status === "PJ") {
            //현재 포장완료 상태
            return (
                <div className="catagory_button_box">
                   {/* <button type="button" className="r_btn_v btn_v1" onClick={(e) => { this.handleComplete_Click(e, 'GR') }}>거래완료</button>*/}
                    <button type="button" className="btn_v btn_inactive" onClick={(e) => { this.handleCancel_Click(e, 'CS') }}>주문취소</button>
                </div>
            )
        }
        else if (ord_status === "GR") {
            return (
                ""
            )
        }
        else {
            return (
                ""
            )
        }
    }
    render() {
        const Summary = this.state.Summary;
        let retail_user_phone, account_holder, retail_area_nm, retail_org_name;
        let ord_status, ord_status_nm, ord_use, ord_use_nm, pay_idx, pay_idx_nm, ord_dt;
        let bumastername = "";
        let qstgrp_no = ""; //문의번호
        if (Summary.length > 0) {
            const Data = Summary[0];
            retail_user_phone = Data.retail_user_phone;
            retail_area_nm = Data.retail_area_nm === "" ? "" : `[${Data.retail_area_nm}]`;
            retail_org_name = Data.retail_org_name;
            account_holder = Data.account_holder;

            ord_status = Data.ord_status;
            ord_status_nm = Data.ord_status_nm;
            ord_use = Data.ord_use;
            this.Ord_Use = Data.ord_use;
            ord_use_nm = Data.ord_use_nm;
            pay_idx = Data.pay_idx;
            pay_idx_nm = Data.pay_idx_nm;
            ord_dt = Data.ord_dt;

            bumastername = Data.bumastername;
            qstgrp_no = Data.qstgrp_no || ""
        }
        const QuestionUrl = `/Order/QuestionMgr/Index?qstgrp_no=${qstgrp_no}&union_uid=${this.Union_Uid}&whole_name=${retail_org_name}`;
        const Goodsrender = this.Goodsrender();
        const Buttonrender = this.Buttonrender(ord_status);
        return (
            <div className="container_box   d_padding  p_b_margin">
                <div className="order_shop_info_box">
                    <div className="shop_name">{retail_area_nm} {retail_org_name}</div>
                    <div className="date">{ord_dt}</div>
                    <div className="shop_info_first_line">
                        <div className="shop_info_1">전화번호 : {retail_user_phone}</div>
                        {ord_use === "SS" ? <div className="shop_info_2 shop_buyer">사입자 : {bumastername }</div> : <div className="shop_info_2 shop_buyer">{ord_use_nm}</div>}
                       
                    </div>
                    <div className="shop_info_second_line">
                        <div className="shop_info_1">{pay_idx_nm}</div>
                        {pay_idx === "OL" ? <div className="shop_info_2">입금자 : {account_holder}</div> : ""}
                    </div>
                    <div className="order_status">{ord_status_nm}</div>
                    {qstgrp_no === "" ? "" : <Link to={QuestionUrl} ><div className="chat_icon"></div></Link>}

                </div>
                <div className="d_info_txt">
                    상품은 <span>클로디 삼촌</span>이 픽업합니다. <br></br>
                    <span>사입과 동일하게</span> 포장하시면 됩니다.
                </div>
                {Goodsrender}
                {Buttonrender}
                <Confirm
                    className="icon icon-smile"
                    id="OrderComplete"
                    FirstName="취소"
                    SecondName="포장완료"
                    title={ord_status === "JM" ? "포장완료" : "거래완료"  }
                    content={ord_status === "JM" ? "포장완료를 하시겠습니까?" : "거래를 완료하시겠습니까?"}
                    ConfirmClick={() => {

                        Big3Common.ModalClose(bootstrap, 'OrderComplete');
                        setTimeout(() => {
                            this.handleSubmit_Click();
                        }, 500);                      
                    }}
                />
                <Confirm
                    className="icon icon-alert"
                    id="OrderCancel"
                    FirstName="다시확인"
                    SecondName="취소처리"
                    title="정말로 주문을 취소하시겠습니까?"
                    content="취소한 주문은 복원 할 수 없습니다"
                    ConfirmClick={() => {
                        Big3Common.ModalClose(bootstrap, 'OrderCancel');
                        setTimeout(() => {
                            this.handleSubmit_Click();
                        }, 500);
                    }}
                />
                <Alert
                    id="AlertBox"
                    title={this.state.Title}
                />
            </div>
        )
    }
}